/**
 * The Symagic Server PlanMacro entity.
 * @author Maarten Lensink
 */
import { BreezeService } from '../../core/breeze.service';
var PlanMacro = /** @class */ (function () {
    function PlanMacro() {
    }
    PlanMacro.prototype.moveTo = function (newStart, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        return BreezeService.invokeMethod(this, 'MoveTo', [newStart], afterSave);
    };
    PlanMacro.prototype.scriptInit = function (afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        return BreezeService.invokeMethod(this, 'ScriptInit', [], afterSave);
    };
    PlanMacro.prototype.scriptRun = function (timeout, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        return BreezeService.invokeMethod(this, 'ScriptRun', [timeout], afterSave);
    };
    /**
     * Use this method to remote invoke the copy method on the server for this entity.
     * @param {boolean} [afterSave=false] Boolean to invoke the method after or before the changes are saved.
     * @returns An observable to get the result after the remote invokation.
     * @memberOf PlanMacro
     */
    PlanMacro.prototype.copy = function (afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        BreezeService.invokeMethod(this, 'Copy', [], afterSave);
        return 'APP.DOMAIN.PLAN_MACRO_COPIED';
    };
    PlanMacro.prototype.replaceSubjectsWith = function (instanceOid, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        BreezeService.invokeMethod(this, 'ReplaceSubjectsWith', [instanceOid], afterSave);
        return 'APP.DOMAIN.SUBJECT_REPLACED';
    };
    return PlanMacro;
}());
export { PlanMacro };
